import React from 'react'
import exact from 'prop-types-exact'
import { BookIcon, DoorOpenIcon, BriefCaseIcon } from 'components/icons'
import PropTypes from 'prop-types'

const propTypes = {
  badge: PropTypes.string.isRequired,
  questionText: PropTypes.string,
}

const defaultProps = {}

function ArtistBadge({ badge = '', questionText = '' }) {
  const getBadgeIcon = () => {
    switch (badge) {
      case 'ta_partner_w_schools':
        return <BookIcon aria-hidden />
      case 'ta_interest_employment':
        return <DoorOpenIcon aria-hidden />
      case 'ta_vendor':
        return <BriefCaseIcon aria-hidden />
      default:
        return null
    }
  }

  const badgeIcon = getBadgeIcon()

  if (!badgeIcon) {
    return null
  }

  return (
    <div className="flex-horizontal artist-badge">
      <div className="artist-badge-icon">{badgeIcon}</div>
      <p>
        <strong>{questionText}</strong>
      </p>
    </div>
  )
}

ArtistBadge.propTypes = exact(propTypes)
ArtistBadge.defaultProps = defaultProps

export default React.memo(ArtistBadge)
